import request from 'sb-request'


const fetchFragranceOfTheMonthData = (params) =>
  request.get('rest/engine/perfumeofmonth', params)


export default {
  fetchFragranceOfTheMonthData,
}
